import { ROUTERS } from '@/constant';
import { TDeviceScreen } from '@/services';

/**
 * Map the `screen` field returned by POST /device/client/check onto the
 * tablet-facing route. Shared between the top-level DeviceRouteHandler and
 * each TAB-xx page's own screen-guard.
 */
export const getTabletRouteFromScreen = (screen: TDeviceScreen): string => {
	switch (screen) {
		case 'REGISTER':
			return ROUTERS.TAB_01;
		case 'INACTIVE_NOTICE':
			return ROUTERS.TAB_02;
		case 'LOGIN':
			return ROUTERS.TAB_03;
		default:
			return ROUTERS.TAB_01;
	}
};

export const getMobileRouteFromScreen = (screen: TDeviceScreen): string => {
	switch (screen) {
		case 'REGISTER':
			return ROUTERS.MOB_01;
		case 'PENDING_NOTICE':
			// MOB-03 is the "just submitted" confirmation; only reachable via
			// explicit navigation from MOB-02 on success. A returning PENDING
			// user (reload, bookmark, `확인` → root) should land on MOB-01
			// where the pending variant shows the "awaiting approval" notice.
			return ROUTERS.MOB_01;
		case 'REJECTED_NOTICE':
			// Spec: show MOB-01 with rejection reason.
			return ROUTERS.MOB_01;
		case 'LOGIN':
			return ROUTERS.MOB_04;
		default:
			return ROUTERS.MOB_01;
	}
};
